import { makeAutoObservable, observable } from "mobx";
import type { AnalyticsSource } from "@/lib/analytics";
import type { TDependentDateShift } from "@/types/dependent-date-shift";

/** What the "Move the tasks waiting on this one?" dialog shows and writes (NG-1283). */
export interface TDependentShiftPrompt {
  workspaceSlug: string;
  projectId: string;
  /** The edited task, named in the dialog's copy. */
  taskName: string;
  /** The surface the date edit came from, carried onto the Move write's analytics. */
  source: AnalyticsSource;
  shift: TDependentDateShift;
}

/**
 * The one open dependent-shift prompt, read by the single dialog host in the app
 * shell. UI state only: `useDependentShiftPrompt` fetches the shift and opens it
 * here, so this store calls no service (the api-demand rule).
 *
 * INVARIANT: `open` replaces any prompt still showing, so the dialog's Move
 * always writes the rows on screen, never those of an earlier edit.
 */
export class DependentShiftPromptStore {
  prompt: TDependentShiftPrompt | null = null;

  constructor() {
    // A ref: a prompt is replaced whole, never edited in place, so its rows stay
    // the plain objects the server sent rather than deep observables.
    makeAutoObservable(this, { prompt: observable.ref }, { autoBind: true });
  }

  open(prompt: TDependentShiftPrompt): void {
    this.prompt = prompt;
  }

  close(): void {
    this.prompt = null;
  }
}
